<template>
  <span
    class="icon-tile"
    :class="[
      'icon-tile--' + variant,
      'icon-tile--' + size,
      { 'icon-tile--stacked': stacked }
    ]"
    aria-hidden="true"
  >
    <font-awesome-icon :icon="icon" />
  </span>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

/* The 2.4rem square that fronts every panel row and every panel card.

   It existed five times before this: .service-aside-icon, .brief-icon,
   .one-off-icon, .why-icon and .quote-icon were the same element written five
   times, two of them at 2.1rem instead of 2.4rem. The mark is one thing, so it
   has one component, and the row that owns it decides its size rather than the
   page.

   The tile deliberately declares no hover of its own. The response (the blue
   glow and the lift) belongs to the row or card the tile sits in, because that
   is what the pointer is actually over. PanelList owns that. */
.icon-tile {
  align-items: center;
  border-radius: $r-md;
  display: inline-flex;
  flex: 0 0 auto;
  justify-content: center;
  transition: box-shadow $dur $ease, transform $dur $ease;

  svg {
    height: 1rem;
    width: 1rem;
  }
}

.icon-tile--md {
  height: 2.4rem;
  width: 2.4rem;
}

.icon-tile--sm {
  height: 2.1rem;
  width: 2.1rem;

  svg {
    height: 0.75rem;
    width: 0.75rem;
  }
}

/* The filled brand tile: every include row, every why card and every quote
   point. It reads on a light ground and on a dark one, which is why the panels
   can share it without a per-tone colour. */
.icon-tile--solid {
  background: $primary;
  color: $on-dark-strong;
}

/* The quiet tile, for a panel already sitting on ink. Outline rather than
   filled, because a second solid blue square inside a dark slab would read as
   an active control instead of a bullet. */
.icon-tile--outline {
  background: $on-dark-fill;
  border: 1px solid $on-dark-line;
  color: $dark-accent;
}

/* Card layout: the tile sits above the title rather than beside it. */
.icon-tile--stacked {
  margin-bottom: 1rem;
}
</style>

<script>
export default {
  props: {
    icon: {
      type: [String, Array, Object],
      required: true
    },
    /* solid | outline */
    variant: {
      type: String,
      default: 'solid'
    },
    /* md (2.4rem) | sm (2.1rem) */
    size: {
      type: String,
      default: 'md'
    },
    stacked: {
      type: Boolean,
      default: false
    }
  }
};
</script>
